<template>
  <div class="modal-actions">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@use '@libero/ui-framework/ModalActions/ModalActions.scss';
</style>
